import { render, staticRenderFns } from "./ProductsCRM.vue?vue&type=template&id=ec39d5aa&scoped=true"
import script from "./ProductsCRM.vue?vue&type=script&lang=js"
export * from "./ProductsCRM.vue?vue&type=script&lang=js"
import style0 from "./ProductsCRM.vue?vue&type=style&index=0&id=ec39d5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec39d5aa",
  null
  
)

export default component.exports